import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import Hero from './components/Hero';
import Editorial from './components/Editorial';
import FeaturedProjects from './components/FeaturedProjects';
import Services from './components/Services';
import Process from './components/Process';
import About from './components/About';
import CoursesSection from './components/CoursesSection';
import FinalCTA from './components/FinalCTA';
import Contact from './components/Contact';
import { useReveal } from '@/hooks/useReveal';

export default function Home() {
  useReveal();

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Editorial />
        <FeaturedProjects />
        <Services />
        <Process />
        <About />
        <CoursesSection />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}